import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom";
import moment from "moment";
import {List, Map} from "immutable";
import {Icon} from "@blueprintjs/core";
import _ from 'lodash';
import numeral from 'numeral';
import {isFloat} from 'validator';

// Components
import DateInput from "../../../components/common/date-input";
import Select from "../../../components/common/virtualized-select";
import QuoteLinesTable from "../../../components/common/QuoteLinesTable";
import SerieSelector from "../../../components/common/SerieSelector";

// Actions
import {createQuote, cleanQuotes} from "../../../actions/quotes";
import {getCustomers, cleanCustomers} from "../../../actions/customers";
import {getCostBreakdowns, cleanCostBreakdowns} from "../../../actions/cost-breakdowns";
import {getProducts, cleanProducts, getProduct} from "../../../actions/products";
import {getSeries, cleanSeries} from "../../../actions/series";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class NewQuote extends Component {
    constructor(props) {
        super(props);
        let customer = -1;

        // New Quote from Customers
        if (this.props.location.state && this.props.location.state.customerId) {
            customer = this.props.location.state.customerId;
        }

        this.state = {
            canSubmit: false,
            canNewLine: false,
            // series
            serieSelectedId: 'manual',
            serieSelectedValue: '',
            // object fields
            quote_code: '',
            document_date: moment(),
            customer,
            cost_breakdown: -1,
            comments: '',
            margin: 0,
            // costPrices
            products: List([]),
            costPrices: List([Map({ _id: -1, price: "Selecciona un precio" })]),
            selectedCostPrice: -1,
            // preview line
            newLinePvp: 0,
            newLineDiscount: 0,
            newLineVat: 0,
            lines: List([]),
            // lines
            product: -1,
            commentsLine: '',
            amount: 0,
            cost_price: 0,
            sale_price: 0,
            discount: 0,
            vat: 0,
            total: 0,
            // Statistics
            quoteSubtotal: numeral(0).format(),
            quoteVat: numeral(0).format(),
            quoteTotal: numeral(0).format(),
            // line edit index
            lineToEditIndex: -1
        };
    }
    componentDidMount() {
        this.validateQuote();
        this.props.getCustomers({
            filters: {
                status: 'active'
            },
            projection: 'customer_code basic_info.name',
            deleteVirtuals: true
        });
        this.props.getProducts({
            filters: {
                status: 'active'
            },
            projection: 'product_code name',
            deleteVirtuals: true
        });
        this.props.getCostBreakdowns({
            projection: 'breakdown_code name',
            deleteVirtuals: true
        });
        this.props.getSeries({ document_type: 'quote' });
    }
    componentDidUpdate(prevProps, prevState) {
        // Calculate Statistics
        if (this.state.lines !== prevState.lines) {
            let quoteSubtotal = 0, quoteVat = 0, quoteTotal = 0;

            this.state.lines.forEach(line => {
                let subtotalCost, discount, subtotal, vat;

                subtotalCost = line.get('amount') * line.get('sale_price');
                discount = subtotalCost * (_.round(line.get('discount'), 2) / 100);
                subtotal = subtotalCost - discount;
                vat = subtotal * (_.round(line.get('vat'), 2) / 100);

                quoteSubtotal = quoteSubtotal + subtotalCost;
                quoteVat = quoteVat + vat;
                quoteTotal = quoteTotal + line.get('total');
            });

            this.setState({
                quoteSubtotal: numeral(quoteSubtotal).format(),
                quoteVat: numeral(quoteVat).format(),
                quoteTotal: numeral(quoteTotal).format()
            });
        }

        // Selected Serie
        if (this.props.series.size > 0 && this.props.series !== prevProps.series) {
            let serieSelectedId = 'manual', serieSelectedValue = '';

            this.props.series.forEach(serie => {
                if (serie.get('is_default')) {
                    serieSelectedId = serie.get('_id');
                    serieSelectedValue = serie.get('prefix') + _.padStart((serie.get('last_count') + 1), serie.get('number_length'), '0')
                }
            });
            this.setState({ serieSelectedId, serieSelectedValue }, this.validateQuote)
        }

        // Handle products and costPrices
        let products = this.props.products;
        if (products !== prevProps.products) {
            if (products instanceof List) {
                if (products.size > 0) {
                    products = products.map(product => {
                        return product.set('select', `[${product.get('product_code')}] ${product.get('name')}`);
                    });
                }
                products = products.insert(0, Map({ _id: -1, select: 'Selecciona un producto' }));
                this.setState({ products });
            }
            else {
                if (products.get('cost_prices')) {
                    this.setState({
                        costPrices: products.get('cost_prices').insert(0, Map({ _id: -1, price: "Selecciona un precio" }))
                    });
                }
            }
        }
    }
    componentWillUnmount() {
        this.props.cleanQuotes();
        this.props.cleanProducts();
        this.props.cleanCostBreakdowns();
        this.props.cleanCustomers();
        this.props.cleanSeries();
    }

    getLineToEdit = index => {
        const line = this.state.lines.get(index);
        const calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), this.state.margin, line.get('discount'), line.get('vat'));

        window.scrollTo(0, 0);

        this.props.getProduct(line.getIn(['product', '_id']), {
            projection: '_id',
            populateRefs: true
        });

        this.setState({
            product: line.getIn(['product', '_id']),
            selectedCostPrice: -1,
            commentsLine: line.get('comments'),
            amount: line.get('amount'),
            cost_price: line.get('cost_price'),
            sale_price: calcLine.salePrice,
            discount: line.get('discount'),
            vat: line.get('vat'),
            newLinePvp: _.round(calcLine.subtotalCost, 2),
            newLineDiscount: _.round(calcLine.discountLine, 2),
            newLineVat: _.round(calcLine.vatLine, 2),
            total: calcLine.total,
            lineToEditIndex: index
        }, this.validateLine);
    };
    deleteLine = index => {
        this.setState({
            lines: this.state.lines.delete(index)
        });
    };
    onChangeSerieSelected = (serieSelectedId, serieSelectedValue) => {
        this.setState({
            serieSelectedId,
            serieSelectedValue,
            quote_code: ''
        }, this.validateQuote);
    };
    validateLine = () => {
        if (
            this.state.product !== -1 &&
            this.state.amount > 0
        ) {
            this.setState({ canNewLine: true }, this.validateQuote);
        } else {
            this.setState({ canNewLine: false }, this.validateQuote);
        }
    };
    validateQuote = () => {
        if (
            (this.state.serieSelectedId !== 'manual' || this.state.quote_code !== '') &&
            this.state.document_date.isValid() &&
            this.state.customer !== -1 &&
            this.state.margin !== ''
        ) {
            this.setState({ canSubmit: true });
        } else {
            this.setState({ canSubmit: false });
        }
    };
    handleCreateClick = () => {
        let lines = new List([]);
        this.state.lines.forEach(line => {
            lines = lines.insert(lines.size, line
                .set('product', line.getIn(['product', '_id']))
                .delete('sale_price')
                .delete('total')
            );
        });

        this.props.createQuote({
            serieSelectedId: this.state.serieSelectedId,
            quote_code: this.state.quote_code,
            document_date: this.state.document_date,
            customer: this.state.customer,
            ...(this.state.cost_breakdown !== -1) ? { cost_breakdown: this.state.cost_breakdown } : '',
            comments: this.state.comments,
            margin: this.state.margin,
            lines,
        }, {
            projection: 'quote_code document_date customer statistics.subtotal statistics.vat statistics.total status',
            populateRefs: [{
                field: 'customer',
                projection: 'basic_info.name'
            }],
            calculateStatistics: 'quotes',
            deleteVirtuals: true
        });
        this.props.history.push('/ventas/presupuestos');
    };
    calculateLine = (amount, costPrice, margin, discount, vat) => {
        let salePrice, subtotalCost, discountLine, subtotal, vatLine, total;
        salePrice = _.round(_.round(costPrice, 5) / (1 - (_.round(margin, 2) / 100)), 2);
        subtotalCost = _.round(amount, 5) * salePrice;
        discountLine = subtotalCost * (_.round(discount, 2) / 100);
        subtotal = subtotalCost - discountLine;
        vatLine = subtotal * (_.round(vat, 2) / 100);
        total = _.round(subtotal + vatLine, 2);

        return {
            salePrice,
            subtotalCost,
            discountLine,
            subtotal,
            vatLine,
            total
        }
    };

    render() {

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/ventas/presupuestos">Presupuestos</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Nuevo Presupuesto</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button
                                className="btn btn-cancel"
                                onClick={ () => this.props.history.push('/ventas/presupuestos') }
                            >Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={ this.handleCreateClick }
                                disabled={!this.state.canSubmit}
                            >Crear
                            </button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Código de presupuesto *</label>
                                                <div className="row">
                                                    <div className="col" style={{ paddingRight: 0 }} >
                                                        { this.state.serieSelectedId === 'manual'
                                                            ? <input
                                                                className="form-control"
                                                                type="text"
                                                                value={this.state.quote_code}
                                                                onChange={ (event) => {
                                                                    this.setState({
                                                                        quote_code: event.target.value
                                                                    }, this.validateQuote);
                                                                }}
                                                            />
                                                            : <input
                                                                className="form-control"
                                                                type="text"
                                                                value={ this.state.serieSelectedValue }
                                                                disabled={true}
                                                            />
                                                        }
                                                    </div>
                                                    <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                                        { this.props.series.size > 0
                                                            ? <SerieSelector
                                                                series={this.props.series}
                                                                serieSelectedId={this.state.serieSelectedId}
                                                                onChangeSerieSelected={this.onChangeSerieSelected}
                                                            />
                                                            : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Fecha presupuesto *</label>
                                                <DateInput
                                                    onChange={(selectedDate) => {
                                                        this.setState({
                                                            document_date: selectedDate
                                                        }, this.validateQuote);
                                                    }}
                                                    value={this.state.document_date}
                                                    inputWrapperStyle={{height: 40}}
                                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                                    iconStyle={{top: 9, right: 12}}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingBottom: 16 }} >
                                        <div className="col-6">
                                            <label>Cliente *</label>
                                            <Select
                                                className="virtualized-select"
                                                options={this.props.customers.toJS()}
                                                value={this.state.customer}
                                                labelKey="select"
                                                valueKey="_id"
                                                matchProp="select"
                                                multi={false}
                                                searchable={true}
                                                clearable={false}
                                                onChange={(customer) => {
                                                    if (customer && customer._id !== this.state.customer) {
                                                        this.setState({
                                                            customer: customer._id,
                                                        }, this.validateQuote);
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label>Escandallo de Costes</label>
                                            <Select
                                                className="virtualized-select"
                                                options={this.props.costBreakdowns.toJS()}
                                                value={this.state.cost_breakdown}
                                                labelKey="select"
                                                valueKey="_id"
                                                matchProp="select"
                                                multi={false}
                                                searchable={true}
                                                clearable={false}
                                                onChange={(costBreakdown) => {
                                                    if (costBreakdown && costBreakdown._id !== this.state.cost_breakdown) {
                                                        this.setState({
                                                            cost_breakdown: costBreakdown._id,
                                                        });
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingBottom: 16 }} >
                                        <div className="col-9">
                                            <label>Comentarios</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.comments}
                                                onChange={ (event) => {
                                                    this.setState({
                                                        comments: event.target.value
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div className="col-3">
                                            <label>Margen (%) *</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.margin}
                                                onChange={ (event) => {
                                                    let margin = event.target.value;
                                                    let lines = List([]);
                                                    let sale_price, subtotalCost, discount, subtotal, vat, total;

                                                    if (margin === '') margin = '0';
                                                    if (margin >= 100) margin = '99';
                                                    if (isFloat(margin)) {
                                                        // actual lines
                                                        this.state.lines.forEach(line => {
                                                            const sale_price = _.round(_.round(line.get('cost_price'), 5) / (1 - (_.round(margin, 2) / 100)), 2);
                                                            const subtotalCost = line.get('amount') * sale_price;
                                                            const discount = subtotalCost * (_.round(line.get('discount'), 2) / 100);
                                                            const subtotal = subtotalCost - discount;
                                                            const vat = subtotal * (_.round(line.get('vat'), 2) / 100);
                                                            const total = _.round(subtotal + vat, 2);
                                                            lines = lines.push(Map({
                                                                _id: line.get('_id'),
                                                                product: line.get('product'),
                                                                comments: line.get('comments'),
                                                                amount: line.get('amount'),
                                                                cost_price: line.get('cost_price'),
                                                                sale_price,
                                                                discount: line.get('discount'),
                                                                vat: line.get('vat'),
                                                                total
                                                            }));
                                                        });
                                                        // new line
                                                        sale_price = _.round(_.round(this.state.cost_price, 5) / (1 - (_.round(margin, 2) / 100)), 2);
                                                        subtotalCost = _.round(this.state.amount, 5) * sale_price;
                                                        discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                                        subtotal = subtotalCost - discount;
                                                        vat = subtotal * (_.round(this.state.vat, 2) / 100);
                                                        total = _.round(subtotal + vat, 2);
                                                        this.setState({
                                                            margin: _.round(margin, 2),
                                                            sale_price,
                                                            newLinePvp: _.round(subtotalCost, 2),
                                                            newLineDiscount: _.round(discount, 2),
                                                            newLineVat: _.round(vat, 2),
                                                            total,
                                                            lines
                                                        }, this.validateQuote);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <h4>Lineas de presupuesto { this.state.lineToEditIndex !== -1 ? <span style={{
                                        paddingLeft: '50px',
                                        color: '#1AB394',
                                        fontStyle: 'italic',
                                        fontWeight: 'bold'
                                    }}>- Modo edición de línea -</span> : '' }</h4>
                                    <div style={{
                                        transition: 'all 0.4s',
                                        margin: '0 -10px',
                                        padding: '10px 10px 0',
                                        ...this.state.lineToEditIndex !== -1 ? { boxShadow: '0 0 10px 1px #1AB394' } : {}
                                    }}>
                                        <div className="row" style={{ paddingBottom: 16 }} >
                                            <div className="col-3">
                                                <label>Producto *</label>
                                                <Select
                                                    className="virtualized-select"
                                                    options={this.state.products.toJS()}
                                                    value={this.state.product}
                                                    labelKey="select"
                                                    valueKey="_id"
                                                    matchProp="select"
                                                    multi={false}
                                                    searchable={true}
                                                    clearable={false}
                                                    onChange={(product) => {
                                                        if (product && product._id !== this.state.product) {
                                                            this.props.getProduct(product._id, {
                                                                projection: '_id',
                                                                populateRefs: true
                                                            });
                                                            this.setState({
                                                                product: product._id,
                                                                selectedCostPrice: -1
                                                            }, this.validateLine);
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-3">
                                                <label>Últimos costes del producto</label>
                                                <Select
                                                    className="virtualized-select"
                                                    options={this.state.costPrices.toJS()}
                                                    value={this.state.selectedCostPrice}
                                                    labelKey="price"
                                                    valueKey="_id"
                                                    matchProp="price"
                                                    multi={false}
                                                    searchable={true}
                                                    clearable={false}
                                                    disabled={this.state.product === -1 || this.state.costPrices.size <= 1}
                                                    onChange={(selectedCostPrice) => {
                                                        if (selectedCostPrice) {
                                                            if (selectedCostPrice._id !== -1) {
                                                                let cost_price = selectedCostPrice.price;
                                                                let sale_price, subtotalCost, discount, subtotal, vat, total;

                                                                if (cost_price === '') cost_price = '0';
                                                                if (isFloat(cost_price.toString())) {
                                                                    sale_price = _.round(_.round(cost_price, 5) / (1 - (_.round(this.state.margin, 2) / 100)), 2);
                                                                    subtotalCost = _.round(this.state.amount, 5) * sale_price;
                                                                    discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                                                    subtotal = subtotalCost - discount;
                                                                    vat = subtotal * (_.round(this.state.vat, 2) / 100);
                                                                    total = _.round(subtotal + vat, 2);

                                                                    this.setState({
                                                                        selectedCostPrice: selectedCostPrice._id,
                                                                        cost_price,
                                                                        sale_price,
                                                                        newLinePvp: _.round(subtotalCost, 2),
                                                                        newLineDiscount: _.round(discount, 2),
                                                                        newLineVat: _.round(vat, 2),
                                                                        total
                                                                    });
                                                                }
                                                            }
                                                            else {
                                                                this.setState({ selectedCostPrice: selectedCostPrice._id });
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row" style={{ paddingBottom: 16 }} >
                                            <div className="col-6">
                                                <label>Comentarios</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.commentsLine}
                                                    onChange={ (event) => {
                                                        this.setState({
                                                            commentsLine: event.target.value
                                                        });
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                        </div>
                                        <div className="row" style={{ paddingBottom: 16 }} >
                                            <div className="col">
                                                <label>Cantidad *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.amount}
                                                    onChange={ (event) => {
                                                        let amount = event.target.value;
                                                        let sale_price, subtotalCost, discount, subtotal, vat, total;

                                                        if (amount === '') amount = '0';
                                                        if (isFloat(amount)) {
                                                            sale_price = _.round(_.round(this.state.cost_price, 5) / (1 - (_.round(this.state.margin, 2) / 100)), 2);
                                                            subtotalCost = _.round(amount, 5) * sale_price;
                                                            discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                                            subtotal = subtotalCost - discount;
                                                            vat = subtotal * (_.round(this.state.vat, 2) / 100);
                                                            total = _.round(subtotal + vat, 2);

                                                            this.setState({
                                                                amount,
                                                                sale_price,
                                                                newLinePvp: _.round(subtotalCost, 2),
                                                                newLineDiscount: _.round(discount, 2),
                                                                newLineVat: _.round(vat, 2),
                                                                total
                                                            }, this.validateLine);
                                                        }
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>Precio coste ud *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.cost_price}
                                                    onChange={ (event) => {
                                                        let cost_price = event.target.value;
                                                        let sale_price, subtotalCost, discount, subtotal, vat, total;

                                                        if (cost_price === '') cost_price = '0';
                                                        if (isFloat(cost_price)) {
                                                            sale_price = _.round(_.round(cost_price, 5) / (1 - (_.round(this.state.margin, 2) / 100)), 2);
                                                            subtotalCost = _.round(this.state.amount, 5) * sale_price;
                                                            discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                                            subtotal = subtotalCost - discount;
                                                            vat = subtotal * (_.round(this.state.vat, 2) / 100);
                                                            total = _.round(subtotal + vat, 2);

                                                            this.setState({
                                                                cost_price,
                                                                sale_price,
                                                                newLinePvp: _.round(subtotalCost, 2),
                                                                newLineDiscount: _.round(discount, 2),
                                                                newLineVat: _.round(vat, 2),
                                                                total
                                                            });
                                                        }
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>PVP ud *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.sale_price}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>Descuento (%)</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.discount}
                                                    onChange={ (event) => {
                                                        let discount = event.target.value;
                                                        let subtotalCost, discountLine, subtotal, vat, total;

                                                        if (discount === '') discount = '0';
                                                        if (isFloat(discount)) {
                                                            subtotalCost = _.round(this.state.amount, 5) * this.state.sale_price;
                                                            discountLine = subtotalCost * (_.round(discount, 2) / 100);
                                                            subtotal = subtotalCost - discountLine;
                                                            vat = subtotal * (_.round(this.state.vat, 2) / 100);
                                                            total = _.round(subtotal + vat, 2);

                                                            this.setState({
                                                                discount,
                                                                newLinePvp: _.round(subtotalCost, 2),
                                                                newLineDiscount: _.round(discountLine, 2),
                                                                newLineVat: _.round(vat, 2),
                                                                total
                                                            });
                                                        }
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>IVA (%) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.vat}
                                                    onChange={ (event) => {
                                                        let vat = event.target.value;
                                                        let subtotalCost, discount, subtotal, total;

                                                        if (vat === '') vat = '0';
                                                        if (isFloat(vat)) {
                                                            subtotalCost = _.round(this.state.amount, 5) * this.state.sale_price;
                                                            discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                                            subtotal = subtotalCost - discount;
                                                            vat = subtotal * (_.round(vat, 2) / 100);
                                                            total = _.round(subtotal + vat, 2);

                                                            this.setState({
                                                                vat: event.target.value,
                                                                newLinePvp: _.round(subtotalCost, 2),
                                                                newLineDiscount: _.round(discount, 2),
                                                                newLineVat: _.round(vat, 2),
                                                                total
                                                            });
                                                        }
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>PVP (€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.newLinePvp}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>Descuento (€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.newLineDiscount}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>IVA (€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.newLineVat}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>Total (€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.total}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col-auto" style={{ paddingTop: 23 }} >
                                                { this.state.lineToEditIndex !== -1
                                                    ? <button
                                                        className="btn btn-primary"
                                                        disabled={!this.state.canNewLine}
                                                        onClick={() => {
                                                            let lines = new List(this.state.lines);
                                                            let index = this.state.products.findIndex( product => product.get('_id') === this.state.product );
                                                            const product = this.state.products.get(index);

                                                            lines = lines.set(this.state.lineToEditIndex, Map({
                                                                product,
                                                                comments: this.state.commentsLine,
                                                                amount: _.round(this.state.amount, 5),
                                                                cost_price: _.round(this.state.cost_price, 5),
                                                                sale_price: this.state.sale_price,
                                                                discount: _.round(this.state.discount, 2),
                                                                vat: _.round(this.state.vat, 5),
                                                                total: _.round(this.state.total, 2)
                                                            }));

                                                            this.setState({
                                                                lines,
                                                                product: -1,
                                                                selectedCostPrice: -1,
                                                                commentsLine: '',
                                                                amount: 0,
                                                                cost_price: 0,
                                                                sale_price: 0,
                                                                vat: 0,
                                                                newLinePvp: 0,
                                                                newLineDiscount: 0,
                                                                newLineVat: 0,
                                                                discount: 0,
                                                                total: 0,
                                                                canNewLine: false,
                                                                lineToEditIndex: -1
                                                            }, this.validateQuote);
                                                        }}
                                                    >
                                                        <Icon
                                                            style={{ margin: '2px 0px' }}
                                                            icon="tick" title="Guardar"
                                                        />
                                                    </button>
                                                    : <button
                                                        className="btn btn-custom"
                                                        disabled={!this.state.canNewLine}
                                                        onClick={() => {
                                                            let lines = new List(this.state.lines);
                                                            let index = this.state.products.findIndex( product => product.get('_id') === this.state.product );
                                                            const product = this.state.products.get(index);

                                                            lines = lines.insert(lines.size, Map({
                                                                product,
                                                                comments: this.state.commentsLine,
                                                                amount: _.round(this.state.amount, 5),
                                                                cost_price: _.round(this.state.cost_price, 5),
                                                                sale_price: this.state.sale_price,
                                                                discount: _.round(this.state.discount, 2),
                                                                vat: _.round(this.state.vat, 5),
                                                                total: _.round(this.state.total, 2)
                                                            }));

                                                            this.setState({
                                                                lines,
                                                                product: -1,
                                                                selectedCostPrice: -1,
                                                                commentsLine: '',
                                                                amount: 0,
                                                                cost_price: 0,
                                                                sale_price: 0,
                                                                vat: 0,
                                                                newLinePvp: 0,
                                                                newLineDiscount: 0,
                                                                newLineVat: 0,
                                                                discount: 0,
                                                                total: 0,
                                                                canNewLine: false
                                                            }, this.validateQuote);
                                                        }}
                                                    >
                                                        <Icon
                                                            style={{ margin: '2px 0px' }}
                                                            icon="plus" title="Añadir"
                                                        />
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <QuoteLinesTable
                                        editMode={true}
                                        quoteLines={this.state.lines}
                                        deleteLine={this.deleteLine}
                                        getLineToEdit={this.getLineToEdit}
                                        editLineIndex={this.state.lineToEditIndex}
                                    />
                                    <div className="row stats-zone d-flex justify-content-end">
                                        <div className="col-auto">
                                            <span className="label ">{ this.state.quoteSubtotal }</span>
                                            <span>Subtotal</span>
                                        </div>
                                        <div className="col-auto">
                                            <span className="label ">{ this.state.quoteVat }</span>
                                            <span>IVA</span>
                                        </div>
                                        <div className="col-auto">
                                            <span className="label ">{ this.state.quoteTotal }</span>
                                            <span>Total</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const customersReducer = state.customers;
    const costBreakdownsReducer = state.costBreakdowns;
    const productsReducer = state.products;
    const seriesReducer = state.series;

    // Customers
    let customers = customersReducer.get('payload') || List([]);
    if (!(customers instanceof List)) customers = List([]);
    if (customers.size > 0) {
        customers = customers.map(customer => {
            return customer.set('select', `[${customer.get('customer_code')}] ${customer.getIn(['basic_info', 'name'])}`);
        });
    }
    customers = customers.insert(0, Map({ _id: -1, select: 'Selecciona un cliente' }));

    // CostBreakdowns
    let costBreakdowns = costBreakdownsReducer.get('payload') || List([]);
    if (!(costBreakdowns instanceof List)) costBreakdowns = List([]);
    if (costBreakdowns.size > 0) {
        costBreakdowns = costBreakdowns.map(costBreakdown => {
            return costBreakdown.set('select', `[${costBreakdown.get('breakdown_code')}] ${costBreakdown.get('name')}`);
        });
    }
    costBreakdowns = costBreakdowns.insert(0, Map({ _id: -1, select: 'Selecciona un escandallo de costes' }));

    // Products
    const products = productsReducer.get('payload') || List([]);

    // Series
    let series = seriesReducer.get('payload') || List([]);

    return {
        customers,
        costBreakdowns,
        products,
        series
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCustomers: (query) => dispatch(getCustomers(query)),
        getCostBreakdowns: (query) => dispatch(getCostBreakdowns(query)),
        getProducts: (query) => dispatch(getProducts(query)),
        getProduct: (productId, options) => dispatch(getProduct(productId, options)),
        getSeries: (query) => dispatch(getSeries(query)),
        createQuote: (quote, options) => dispatch(createQuote(quote, options)),
        cleanQuotes: () => dispatch(cleanQuotes()),
        cleanCustomers: () => dispatch(cleanCustomers()),
        cleanCostBreakdowns: () => dispatch(cleanCostBreakdowns()),
        cleanProducts: () => dispatch(cleanProducts()),
        cleanSeries: () => dispatch(cleanSeries())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewQuote);



// WEBPACK FOOTER //
// ./src/containers/sales/quotes/NewQuote.js